import React from 'react'
import { Mdx } from '@ta-interaktiv/contentbricks'
import './styles.scss'

interface Props {
  content: MarkedInterface
  lang: 'de' | 'fr'
}

export const DetailView = ({ content, lang }: Props) => {
  const { textid, imgid } = content

  return (
    <div className='DetailView'>
      <div className='content'>
        <div className='infowrapper'>
          {imgid && <img src={require('images/img_' + imgid + '.jpg')} />}
        </div>
        {textid && (
          <div className='text'>
            <Mdx
              file={require('components/_data/texte/' +
                textid +
                '_' +
                lang +
                '.mdx')}
            />
          </div>
        )}
      </div>
    </div>
  )
}
